<template>
  <div>
    <v-data-table
      :footer-props="{
        'items-per-page-text': 'Datensätze pro Seite',
        'items-per-page-all-text': 'Alle',
        'page-text': '{0}-{1} von {2}'
      }"
      :headers="headers"
      :items="orders"
      :items-per-page="10"
      class="elevation-1"
      :height="500"
    >
      <template #[`item.name`]="{ item }">
        <span v-html="item.name"></span>
      </template>
      <template #[`item.sheetAmount`]="{ item }">
        <span v-html="item.sheetAmount"></span>
      </template>
      <template #[`item.weight`]="{ item }">
        <span v-html="item.weight"></span>
      </template>
      <template #[`item.fullBatches`]="{ item }">
        <span v-html="item.fullBatches"></span>
      </template>
      <template #[`item.partialBatches`]="{ item }">
        <span v-html="item.partialBatches"></span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
export default {
  props: {
    orders: {
      type: Array
    }
  },
  data: () => ({
    content: {},
    isValidationDialogOpen: false,
    validationResult: null,
    isErrorDialogOpen: false,
    items: this.orders
  }),
  created: function () {
    // argument is cms api-endpoint
    this.generateHeaders()
    this.fetchDocuments()
  },
  methods: {
    generateHeaders() {
      this.headers = [
        {
          text: 'Name',
          value: 'name',
          sortable: false
        },
        {
          text: 'Blatt',
          value: 'sheetAmount',
          align: 'start'
        },
        {
          text: 'Gewicht',
          value: 'weight',
          align: 'start'
        },
        {
          text: 'Volle Lose',
          value: 'fullBatches',
          align: 'end'
        },
        {
          text: 'Restlose',
          value: 'partialBatches',
          align: 'end'
        }
      ]
    },
    sumUpItems(key) {
      return this.items.reduce((a, b) => a + (b[key] || 0), 0)
    }
  }
}
</script>

<style></style>
